module.exports = __webpack_public_path__ + "static/media/moon.4f19d10d.png";